<template>
  <div>
    <UnPatrolListComponent
      typeName="巡回清掃 未点検一覧"
      :type="2"
      settionStrageName="RoundUnpatrolListStorageItemName">
    </UnPatrolListComponent>
  </div>
</template>

<script>
import UnPatrolListComponent from '../../Patrol/components/UnPatrolListComponent.vue'
import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    UnPatrolListComponent
  },
}
</script>